export const faqItem = () => ({
  open: false,
  toggle() {
    this.open = !this.open;
    this.$refs.icon.classList.toggle('-rotate-180');
  },
});
